<div class="forgot-password-split-container">
  <div class="forgot-password-illustration">
    <div class="illustration-content">
      <h2 class="illustration-title">Password Recovery</h2>
      <img
        ngSrc="/assets/img/data-management.png"
        alt="hero-image"
        class="illustration-img"
        width="400"
        height="300"
      />
    </div>
  </div>
  <div class="forgot-password-form-container">
    <div class="forgot-password-form-box">
      <h1 class="forgot-password-title">AZAADI 2.0</h1>

      <div *ngIf="!emailSent" class="form-content">
        <p class="forgot-password-welcome">
          Forgot your password? No worries! Enter your email address and we'll
          send you a reset link.
        </p>
        <form
          [formGroup]="forgotPasswordForm"
          (ngSubmit)="onSubmit()"
          novalidate
        >
          <div class="form-group">
            <label for="email">Email ID</label>
            <input
              type="email"
              id="email"
              formControlName="email"
              required
              autocomplete="username"
              placeholder="Enter your email"
            />
            <div
              class="error"
              *ngIf="
                forgotPasswordForm.get('email')?.touched &&
                forgotPasswordForm.get('email')?.invalid
              "
            >
              <span
                *ngIf="forgotPasswordForm.get('email')?.errors?.['required']"
                >Email is required.</span
              >
              <span *ngIf="forgotPasswordForm.get('email')?.errors?.['email']"
                >Invalid email format.</span
              >
            </div>
          </div>
          <button
            type="submit"
            class="forgot-password-btn"
            [disabled]="loading"
          >
            <span *ngIf="loading" class="spinner"></span>
            <span *ngIf="!loading">Send Reset Link</span>
          </button>
        </form>
        <div class="form-actions">
          <button
            type="button"
            class="back-to-login-btn"
            (click)="goBackToLogin()"
          >
            ← Back to Login
          </button>
        </div>
      </div>

      <div *ngIf="emailSent" class="success-content">
        <div class="success-icon">✓</div>
        <h3 class="success-title">Email Sent!</h3>
        <p class="success-message">
          We've sent a password reset link to your email address. Please check
          your inbox and follow the instructions to reset your password.
        </p>
        <div class="success-info">
          <p><strong>Important:</strong></p>
          <ul>
            <li>The reset link will expire in 15 minutes for security</li>
            <li>Check your spam folder if you don't see the email</li>
            <li>The link can only be used once</li>
          </ul>
        </div>
        <div class="success-actions">
          <button type="button" class="resend-btn" (click)="resendEmail()">
            Resend Email
          </button>
          <button
            type="button"
            class="back-to-login-btn"
            (click)="goBackToLogin()"
          >
            Back to Login
          </button>
        </div>
      </div>

      <footer class="forgot-password-footer">
        ©{{ currentYear }} AZAADI. All rights reserved.
      </footer>
    </div>
  </div>
</div>
